<template>
  <div>
    <!-- TODO -->
  </div>
</template>

<script setup lang="ts">
const menuStore = useMenuStore();
const optionsStore = useOptionsStore();

await Promise.all([
  callOnce(menuStore.fetchAll),
  callOnce(optionsStore.fetchAll)
]);
</script>
